export default "__VITE_ASSET__BMaWdUsA__"